/**
 * MER-688: copy for the RED-flag toast, split by session kind.
 *
 * Findings is a Meridian-internal surface (staff only since MER-688), so a
 * client's toast must not name it or offer a link to it; the client can
 * act on the flag where it shows, on the marked tiles. Staff keep the
 * "View Findings" action. Pure so node:test pins both shapes;
 * flagStream.ts attaches the navigation onClick for staff.
 */

export const RED_FLAG_BODY_STAFF = "A RED flag was raised. Review on the Findings tab.";
export const RED_FLAG_BODY_CLIENT =
  "A RED flag was raised on this dashboard. The affected tiles are marked.";
export const RED_FLAG_ACTION_LABEL = "View Findings";

/**
 * @param {number} delta  New RED flags since the last poll (>= 1).
 * @param {{ isStaff?: boolean }} [opts]  Only a strict boolean true is staff.
 * @returns {{ title: string, body: string, actionLabel: string | null }}
 *   actionLabel is null for a client: no action is rendered at all.
 */
export function formatRedFlagToast(delta, opts = {}) {
  const staff = opts.isStaff === true;
  return {
    title: `${delta} new critical alert${delta === 1 ? "" : "s"}`,
    body: staff ? RED_FLAG_BODY_STAFF : RED_FLAG_BODY_CLIENT,
    actionLabel: staff ? RED_FLAG_ACTION_LABEL : null,
  };
}
